module.exports = __webpack_public_path__ + "addbefeb31cf1888e8aebe974e31ee93.svg";